var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9116 0V43.0872",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9116 51.7047V94.7919",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4556 14.0033L44.785 44.4706",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5444 14.0033L51.215 44.4706",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9373 50.4121L14.6078 80.8794",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0627 50.4121L81.3922 80.8794",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.515381 47.3959H43.4077",
    stroke: "#FF7A00",
    strokeWidth: 14
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4846 47.3959H52.5923",
    stroke: "#FF7A00",
    strokeWidth: 14
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.638d860fccd64dee165c32d1894c659e.svg";
export { ForwardRef as ReactComponent };